import React, { useState, useEffect } from 'react'
import {
  Form,
  Pagination,
  Button,
  Modal,
  Container,
  Col,
  Row,
} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import { BsPerson } from 'react-icons/bs'
import { FaEye, FaEdit, FaTrash, FaUniversity, FaSyncAlt } from 'react-icons/fa'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import { PencilSquare } from 'react-bootstrap-icons'
import EditInstituteModal from './EditInstituteModal'

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'

const AddInstitute = () => {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedInstitute, setSelectedInstitute] = useState(null)

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    ApiEndpoints.getAllInstitutes()
      .then((response) => {
        console.log(response.data.data)
        setData(response.data.data)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])
  const [newInstitute, setNewInstitute] = useState({
    name: '',
    address: '',
    pincode: '',
  })

  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)
  const highlightText = (text, search) => {
    if (!search) return text

    const lowerText = text.toString().toLowerCase()
    const lowerSearch = search.toLowerCase()

    // Check if all characters from search exist in the text
    const allCharsMatch = [...lowerSearch].every((char) =>
      lowerText.includes(char),
    )

    if (!allCharsMatch) {
      // Return plain text if any character is missing
      return text
    }

    // Highlight matching characters
    return text
      .toString()
      .split('')
      .map((char, i) => {
        return lowerSearch.includes(char.toLowerCase()) ? (
          <span key={i} style={{ backgroundColor: 'yellow', color: 'black' }}>
            {char}
          </span>
        ) : (
          <span key={i}>{char}</span>
        )
      })
  }

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    console.log(
      `Input Changed - Name: ${name}, Value: ${value} (Type: ${typeof value})`,
    )
    setNewInstitute((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    try {
      setLoading(true)
      console.log('Sending data: ', newInstitute)
      const response = await ApiEndpoints.addInstitute(newInstitute)
      setNewInstitute('Response: ', response)
      // setData(response.data)
      // Reset the form after submission
      setNewInstitute({
        name: '',
        address: '',
        pincode: '',
      })

      toast.success(response.data.message)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.message || 'Something wents wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    setSelectedInstitute({})

    setData(data)
    setSearch('')
    setCurrentPage(1)
  }

  return (
    <div style={{ marginLeft }}>
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 768 ? '55px' : '-12px',
        }}
      >
        <div className="bg-secondary p-3 rounded d-flex flex-wrap justify-content-between align-items-center text-white">
          <h2 className="m-0">Institutes</h2>
          <Button
            variant="light"
            className="fw-bold"
            onClick={() => setShowModal(true)}
          >
            <FaUniversity size={18} className="me-2" />
            Add New Institute
          </Button>
        </div>
      </div>

      <Row className="g-2 align-items-center justify-content-between mt-4">
        <Col md={3}>
          <Form.Control
            type="text"
            placeholder="Search Institute Name"
            className="w-100"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Col>
        <Col xs="auto">
          <Button
            variant="outline-primary"
            onClick={handleRefresh}
            title="Refresh"
            className="w-auto"
          >
            <FaSyncAlt /> Refresh
          </Button>
        </Col>
      </Row>

      <div className="d-flex justify-content-end align-items-center gap-3 mb-3 mt-4">
        <p className="text-black m-0">
          Total Institutes: {filteredData.length}
        </p>
        <Form.Select
          className="w-auto"
          value={itemsPerPage}
          onChange={(e) => {
            setItemsPerPage(parseInt(e.target.value))
            setCurrentPage(1)
          }}
        >
          <option value="10">10 per page</option>
          <option value="20">20 per page</option>
          <option value="30">30 per page</option>
        </Form.Select>
      </div>
      <Table className="table table-striped table-bordered table-hover rounded overflow-hidden shadow-sm mb-0">
        <Thead className="bg-dark text-white">
          <Tr>
            <Th>Institute Name</Th>
            <Th>Address</Th>
            <Th>Pincode</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <Tr key={index} className="align-middle">
                <Td>{highlightText(item.name, search)}</Td>
                <Td>{item.address}</Td>
                <Td>{item.pincode}</Td>

                <Td className="text-center">
                  <div className="d-flex flex-wrap justify-content-start gap-2">
                    {/* View Button */}
                    {/* <Button
                      variant="info"
                      className="d-flex justify-content-center align-items-center p-2"
                    >
                      <FaEye />
                    </Button> */}

                    {/* Edit Button */}
                    <Button
                      variant="warning"
                      onClick={() => {
                        setSelectedInstitute(item)
                        setShowEditModal(true)
                      }}
                    >
                      <PencilSquare />
                    </Button>
                    {/* Delete Button */}
                    {/* <Button
                      variant="danger"
                      className="d-flex justify-content-center align-items-center p-2"
                      onClick={() => deleteClass(item.classId)}
                    >
                      <FaTrash />
                    </Button> */}
                  </div>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td
                colSpan="9"
                className="d-flex flex-wrap justify-content-start justify-content-md-center gap-2"
              >
                No records found
              </Td>
            </Tr>
          )}
        </Tbody>
      </Table>

      <div className="d-flex justify-content-end align-items-center mb-4">
        <Pagination className="mt-2">
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

      {/* Add New Class Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton className="text-white bg-secondary">
          <Modal.Title>Add New Institute</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Class Name Field */}
            <Form.Group className="mb-3">
              <Form.Label>Institute Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={newInstitute.name}
                onChange={handleInputChange}
                placeholder="Enter Institute Name"
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="textarea"
                name="address"
                value={newInstitute.address}
                onChange={handleInputChange}
                placeholder="Enter Address"
                className="p-2 border rounded"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Pincode</Form.Label>
              <Form.Control
                type="number"
                name="pincode"
                value={newInstitute.pincode}
                onChange={handleInputChange}
                placeholder="Enter Pincode"
                className="p-2 border rounded"
                required
              />
            </Form.Group>

            {/* <Form.Group className="mb-3">
              <Form.Label>Course</Form.Label>
              <Form.Select
                name="course_id"
                value={newClass.course_id}
                onChange={handleInputChange}
              >
                <option value="">Select Course</option>
                {institutes.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group> */}

            {/* Teacher Selection */}
            {/* <Form.Group className="mb-3">
              <Form.Label >Teacher</Form.Label>
              <Form.Select
                name="teacher"
                value={newClass.teacher}
                onChange={handleInputChange}
                className="p-2 border rounded"
              >
                <option value="Prem Sir">Prem Sir</option>
                <option value="Lucky Sir">Lucky Sir</option>
                <option value="Ambika Sir">Ambika Sir</option>
                <option value="Avinash Sir">Avinash Sir</option>
              </Form.Select>
            </Form.Group> */}
            <Modal.Footer>
              <Button
                variant="danger"
                className="rounded-pill px-4"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                className="rounded-pill px-4"
                type="submit"
              >
                Save Institute
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      <EditInstituteModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        institute={selectedInstitute}
      />
    </div>
  )
}

export default AddInstitute
